export const SnackAuditQuestions = [
  {
    mainQuestion: "",
    questions: ["1. Snack cart is prepared by staff on time?"],
  },
  {
    mainQuestion: "",
    questions: [
      "2. Are residents provided with any eating aides/assistive devices required to safely eat and drink as comfortably and independently as possible (i.e. nosey cup, sipper cup)",
    ],
  },
  {
    mainQuestion: "",
    questions: ["3. Staff washed their hands before delivery of snacks?"],
  },
  {
    mainQuestion: "",
    questions: ["4. Snack cart is neat and clean?"],
  },
  {
    mainQuestion: "",
    questions: [
      "5. Were the resident's hands sanitised prior to providing snack?",
    ],
  },
  {
    mainQuestion:
      "6. Are there any signs of skin irritation or redness on the resident's face?",
    questions: [
      "a. Beverages as per snack menu (juices, diet drinks, milk, tea, coffee)",
      "b. Choices for therapeutic diets (clearly marked)",
      "c. Sugar/artificial sweeteners, creamers",
      "d. Snack foods for regular and therapeutic diets, per snack menu ",
    ],
  },
  {
    mainQuestion: "",
    questions: ["7. Snack foods are prepared according to established menu?"],
  },
  {
    mainQuestion: "",
    questions: [
      "8. Snack foods are available for all diet types, textures and consistencies?",
    ],
  },
  {
    mainQuestion: "9. Adequate supplies are available for snack service:",
    questions: [
      "a. Eating utensils, cups, glasses",
      "b. Napkins",
      "c. Tongs/serving utensils",
    ],
  },
  {
    mainQuestion: "",
    questions: [
      "10. All residents prescribed nutritional supplements and special snacks are available and labelled correctly with residents, name and diet?",
    ],
  },
  {
    mainQuestion: "",
    questions: [
      "11. If a supplement or nourishment is not taken, is it documented and communicated to dietary to be reviewed and followed up by RD?",
    ],
  },
  {
    mainQuestion: "12. Perishable foods are being held properly on ice",
    questions: [
      "a. Staff use appropriate tools for the delivery of snacks and do not touch the food with bare hands?",
    ],
  },
  {
    mainQuestion: "",
    questions: [
      "13. Staff refers to and follows the Snack Delivery List? (resident information on the cart)",
    ],
  },
  {
    mainQuestion: "",
    questions: [
      "14. Residents on a specified diet and texture receive correct snacks as per Diet Order and Snack Delivery List?",
    ],
  },
  {
    mainQuestion: "15. Snacks are handed out to residents in a timely manner?",
    questions: [
      "a. Supervision and assistance is provided to residents who require it? ",
      "b. Residents are positioned properly?",
      "c. Staff are seated while feeding resident?",
    ],
  },
  {
    mainQuestion: "",
    questions: [
      "16. Snacks are placed within easy access, for those residents who can safely consume them without assistance?",
    ],
  },
  {
    mainQuestion: "",
    questions: ["17. Portion sizes are appropriate?"],
  },
  {
    mainQuestion: "",
    questions: [
      "18. Intakes of all snacks and fluids are recorded accurately and in a timely manner?",
    ],
  },
];

export const DiningAuditQuestions = [
  {
    name: "ENVIRONMENT",
    tag: "environment",
    questions: [
      "a. Is the menu posted near the dining area?",
      "b. Are mealtimes free from distractions?",
      "c. Is the dining room clean; has a pleasant odor free from debris on floor spills cleaned promptly and furniture in good repair? Is the lighting adequate? Temperature comfortable?",
      "d. Is there clear access to tables by residents or staff?",
      "e. Are meals served at the same time for everyone seated at the same table?",
    ],
  },
  {
    name: "SETUP",
    tag: "setup",
    questions: [
      "a. Are residents seated with appropriate table mates?",
      "b. Is the table setting i.e. cutlery dishes visually appealing and suited to needs of those in care?",
      "c. Were residents that needed assistance provided a meal prior to the PSW being able to assist?",
    ],
  },
  {
    name: "ASSISTANCE",
    tag: "assistance",
    questions: [
      "a. Are adaptive equipment/utensils used according to residents’ needs? Cutlery sipper cup rim plate thermal mug/soup",
      "b. Is staff responding to residents’ difficulties with feeding?",
      "c. Do residents who independently feed themselves receive appropriate set-up?",
      "d. For residents who require assistance with feeding are they encouraged to eat and drink as independently as possible but given support as necessary?",
      "e. Were the resident’s hands washed pre-meal and was the resident’s face/hands washed post meal?",
      "f. Are safe feeding practices observed? Feeding resident at eye level etc.",
    ],
  },
  {
    name: "ACTIVITIES/STAFFING",
    tag: "activities",
    questions: [
      "a. Is staff conversing with residents and/or staff-to-staff conversation appropriate and relevant to resident care?",
      "b. Does the meal experience appear dignified?",
      "c. Does the caregiver talk to the resident about the food provided and the resident’s preference for receiving it?",
      "d. Are all choking hazards removed from the tables?",
      "e. Are cues used to encourage interest in the meal?",
      "f. Is each resident offered a choice from the planned menu? Are individual residents’ preferences accommodated at mealtimes?",
    ],
  },
  {
    name: "INTERRUPTION/PACE",
    tag: "interruption",
    questions: [
      "a. Is awareness of appropriate food temperature for serving (foods) evident?",
      "b. Is the pace of the meal served appropriate?",
      "c. Are residents rushed through their meals?",
      "d. Is extra time beyond normal meal time given to residents who eat more slowly?",
    ],
  },
];
